import React, { Component } from "react";
import { createGlobalStyle } from "styled-components";
import "styled-components/macro";

export default class ClickSparksAnimated extends Component {
  Css = createGlobalStyle`
    .spark_0{
      stroke-dasharray:28 30;
      stroke-dashoffset:29;
      animation-play-state: running;
      animation-iteration-count: 2;
      animation:
        spark_draw_0 ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2,
        spark_fade ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2;
    }
    .spark_1{
      stroke-dasharray:25 27;
      stroke-dashoffset:26;
      animation-play-state: running;
      animation:
        spark_draw_1 ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2,
        spark_fade ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2;
    }
    .spark_2{
      stroke-dasharray:15 17;
      stroke-dashoffset:16;
      animation-play-state: running;
      animation:
        spark_draw_2 ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2,
        spark_fade ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2;
    }
    .spark_3{
      stroke-dasharray:17 19;
      stroke-dashoffset:18;
      animation-play-state: running;
      animation:
        spark_draw_3 ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2,
        spark_fade ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2;
    }
    .spark_4{stroke-dasharray:6 8;
      stroke-dashoffset:7;
      animation-play-state: running;
      animation:
        spark_draw_4 ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2,
        spark_fade ${this.props.animationMs * 1.22}ms linear ${
    this.props.animationMs
  * 1.25}ms 2;
    }
    @keyframes spark_draw{100%{stroke-dashoffset:0;
    }}
    @keyframes spark_fade{0%{stroke-opacity:1;}66.66666666666667%{stroke-opacity:1;}100%{stroke-opacity:0;}}
    @keyframes spark_draw_0{0%{stroke-dashoffset: 29}11.111111111111109%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}
    @keyframes spark_draw_1{1.388888888888889%{stroke-dashoffset: 26}12.499999999999996%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}
    @keyframes spark_draw_2{2.777777777777778%{stroke-dashoffset: 16}13.888888888888888%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}
    @keyframes spark_draw_3{4.166666666666666%{stroke-dashoffset: 18}15.277777777777777%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}
    @keyframes spark_draw_4{5.555555555555556%{stroke-dashoffset: 7}16.666666666666664%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}
  `;
  render() {
    return (
      <span
        css={`
          z-index: 1;
          position: relative;
          top: -40px;
          left: -114px;
        `}
      >
        <this.Css />
        <svg
          id="ClickSparksAnimated"
          width="80"
          height="65"
          viewBox="0 0 80 65"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke="#1E1EFF"
            strokeWidth="7"
            strokeLinecap="round"
            d="M48.9277,33.2356L76.009,29.0724"
            className="spark_0"
          ></path>
          <path
            stroke="#1E1EFF"
            strokeWidth="6"
            strokeLinecap="round"
            d="M38.9026,27.3276L38.101,3.09756"
            className="spark_1"
          ></path>
          <path
            stroke="#1E1EFF"
            strokeWidth="6"
            strokeLinecap="round"
            d="M28.813,30.9106L16.684,22.1872"
            className="spark_2"
          ></path>
          <path
            stroke="#1E1EFF"
            strokeWidth="7"
            strokeLinecap="round"
            d="M29.5965,42.868L16.3794,52.0036"
            className="spark_3"
          ></path>
          <path
            transform="matrix(0.825606 -0.564247 -0.564247 -0.825606 3.86938 56.218)"
            stroke="#1E1EFF"
            strokeWidth="7"
            strokeLinecap="round"
            d="M3.5,-3.5L-2.5,-3.5"
            className="spark_4"
          ></path>
        </svg>
      </span>
    );
  }
}
